import { useState } from "react";
import Sidebar from "./components/Sidebar";
import ImageGrid from "./components/ImageGrid";
import MobileHeader from "./components/MobileHeader";

export default function App() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-linen-50">
      {/* Mobile header - only visible on small screens */}
      <MobileHeader onOpenSidebar={() => setIsSidebarOpen(true)} />

      {/* Sidebar - transforms to slide-out drawer on mobile */}
      <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />

      {/* Main content - full width on mobile, offset on desktop */}
      <main className="flex-1 p-4 pt-20 md:pt-8 md:p-8 md:ml-[380px]">
        <ImageGrid />
      </main>
    </div>
  );
}
